import { BlindMatchStatus } from './types'

export type GetOrFetchRecord = (entityId: string) => Promise<any>

export interface ResolvedSource {
  value: any
  errored?: boolean
}

interface SourceConfig {
  source?: string
  sourcePath?: string
  entity?: any
  showUnavailableOnEmptySource?: boolean
}

// Platform-agnostic resolver. Caller supplies getOrFetchRecord so this works
// from both mobile (Api.getStore()) and webapp (apis.getStore()).
export async function resolveSourceValue(
  config: SourceConfig,
  getOrFetchRecord?: GetOrFetchRecord
): Promise<ResolvedSource> {
  const { source, sourcePath, entity } = config

  if (source !== undefined) {
    return { value: source }
  }

  if (!sourcePath) {
    return { value: undefined }
  }

  if (entity && typeof entity.get === 'function') {
    try {
      return { value: entity.get(sourcePath) }
    } catch {
      return { value: undefined, errored: true }
    }
  }

  if (entity && entity.entityId && getOrFetchRecord) {
    try {
      const resolved = await getOrFetchRecord(entity.entityId)
      if (!resolved) {
        return { value: undefined, errored: true }
      }
      return { value: resolved.get(sourcePath) }
    } catch {
      return { value: undefined, errored: true }
    }
  }

  return { value: undefined }
}

export function initialStatusForConfig(config: SourceConfig): BlindMatchStatus {
  const { source, sourcePath, entity } = config
  const needsFetch =
    !source && sourcePath && entity && entity.entityId && typeof entity.get !== 'function'
  return needsFetch ? BlindMatchStatus.Loading : BlindMatchStatus.Precheck
}
